// extracted by mini-css-extract-plugin
export default {"Logo":"logo_Logo__I5fcz","logo":"logo_logo__Yj2Ab","text":"logo_text__U3gn1"};